export default __webpack_public_path__ + "static/media/csc.9ec8062d.gif";